<section>
    <div class="sx-dialog__scroll-area">
      <header class="sx-dialog__content">
        <h2 class="sx-dialog__heading h3">{{'metering.filter.form.title_add' |translate}}</h2>
      </header>
  
      <!-- Filter -->
      <div class="sx-dialog__content sx-dialog-select-metering__filter-wrapper">
        <mat-form-field class="sx-dialog-select-metering__filter" [floatLabel]="'never'">
          <input matInput [(ngModel)]="searchFilter" id="field_search" (keyup)='keyUp.next($event)'
            placeholder="Skriv för att söka" />
          <svg class="sx-filter-pane__search-icon">
            <use xlink:href="#baseline-search-24px" href="#baseline-search-24px" />
          </svg>
        </mat-form-field>
      </div>
      <div class="sx-dialog__content sxl-horizontal-stack sxh-text-light">
        <span class="sxh-text-small">
          <mat-radio-button name="filterType" id="search_name_chkbox" [checked]="!searchAdresses"
            (change)="setFilterType(false)"></mat-radio-button>{{'alarms.form.name'
          | translate}}
        </span>
        <span class="sxh-text-small">
          <mat-radio-button name="filterType" id="search_address_chkbox" [checked]="searchAdresses"
            (change)="setFilterType(true)"></mat-radio-button>{{'alarms.form.adress'
          | translate}}
        </span>
      </div>
  
      <!-- Anläggningar -->
      <div class="sx-dialog__sectioner sxl-space-between" [hidden]="meteringPointsView.length === 0">
        <span>{{'alarms.form.meteringpoint' | translate}}</span>
      </div>
      <div class="sx-dialog__content" [hidden]="meteringPointsView.length === 0">
        <div class="sx-dialog__option-row">
          <mat-checkbox  [checked]="isAllMpsSelected()" id="field_select_all_heat" (change)="toggleAllMps()">{{'customers.meteringpoints.select_all' |
              translate}}</mat-checkbox>
        </div>
        <div class="sx-dialog__option-row" *ngFor="let meteringPoint of meteringPointsView; let i = index">
          <mat-checkbox [checked]="meteringPoint.selected" id="field_select_heat_option_{{i}}" [value]="meteringPoint" (change)="selectMeteringPoint(meteringPoint)"><span>{{searchAdresses ? meteringPoint.addressLabel :
              meteringPoint.name}}</span>
              <span class="sxh-text-mp-id">({{meteringPoint.id}})</span>
              <span class="sxh-text-mp-id" *ngIf="meteringPoint.type ==='LOG'">{{'metering.filter.form.logical' | translate}}</span>
            </mat-checkbox>
        </div>
      </div>
      <div class="sx-dialog__sectioner sxl-space-between" [hidden]="meteringPointsView.length !== 0">
        <app-no-content [displayText]="('alarms.form.empty' | translate)"></app-no-content>
      </div>
    </div>
  
    <!-- Knappar -->
    <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
      <button class="sx-button sx-button--white" appTrackClick sxaction="Button alarm create cancel"  id="form_cancel_btn" mat-button
        (click)="onCancel()">{{'core.button.cancel' | translate}}</button>
      <button class="sx-button sx-button--magenta" appTrackClick sxaction="Button alarm create" id="form_ok_btn" [disabled]="selectedMeteringPoints.length === 0 " mat-button
        (click)="onSave()">{{'core.button.add'
        | translate }}</button>
    </div>
  </section>
  